import React from 'react';
import { AvatarContainer } from './Avatar.styles';

export const Avatar = ({ image }) => {
  return <AvatarContainer src={image} />;
};
